// Module
var code = "<maintenance-flow-models business-id=\"$ctrl.selectedBusinessId\"></maintenance-flow-models> ";
// Exports
export default code;